import React from 'react';
import { useTranslations } from 'use-intl';
import { Typography } from '@/UIlibrary/Typography/Typography';

interface FormContentProps {
	data: {
		type: string;
		data: Record<string, any>;
	};
}

const FormContent: React.FC<FormContentProps> = ({ data }) => {
	const t = useTranslations('Support');

	const entries = Object.entries(data.data);

	if (!data.data || typeof data.data !== 'object') {
		return <div className="p-4">{t('CouldntRetrieve')}</div>;
	}

	const formatKey = (key: string): string => {
		return key
			.split('_')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};

	return (
		<div className="p-4">
			<ul className="space-y-4">
				{entries
					.filter(([key]) => key !== 'flow_token')
					.map((entry, index) => {
						const [key, value] = entry;
						const formattedKey = formatKey(key);
						return (
							<li key={key} className="border-b pb-2 border-gray-200 flex flex-col gap-2">
								<Typography weight="bold">
									{index + 1}. {formattedKey}
								</Typography>
								<Typography color="subtitle">{String(value)}</Typography>
							</li>
						);
					})}
			</ul>
		</div>
	);
};

export default FormContent;
